import { getContext } from '@fiverr-private/fiverr_context';
import { ROLLOUTS, EXPERIMENTS } from '@fiverr-private/listing_experiments';
import { LoyaltyProgramTier } from '@fiverr-private/loyalty_utils';
import { LOYALTY_UPGRADE_TO_PRO_BANNER_SHOWN_ON_LISTINGS_AND_EXPIRE_AFTER } from './consts';

export const shouldShowJoinProRewardsProgramBanner = (
    userLoyaltyProgramStatus: { tier: LoyaltyProgramTier },
    rollouts: { [key: string]: boolean }
) => {
    const { abTests } = getContext();
    const inTestGroup = Number(abTests[EXPERIMENTS.DOLPHINS_LOYALTY_ELIGIBILITY_CELEBRATION_MIGRATION]) === 2;
    const inRollout = rollouts[ROLLOUTS.DOLPHINS_LOYALTY_ELIGIBILITY_PRO_MIGRATION_BANNER];

    const previousDisplayExpireAfter =
        typeof window === 'undefined' || !window.localStorage
            ? 0
            : Number(localStorage.getItem(LOYALTY_UPGRADE_TO_PRO_BANNER_SHOWN_ON_LISTINGS_AND_EXPIRE_AFTER) || 0);

    const currentTimestamp = new Date().getTime();
    return currentTimestamp > previousDisplayExpireAfter && inTestGroup && inRollout && !!userLoyaltyProgramStatus;
};
